<template>
  <div>
    <el-card
      class="card-container"
      shadow="never"
    >
      <CardHeader
        slot="header"
        title="Danh sách quyền hạn"
        :total="total"
        :size="'small'"
        :disabled="loading"
        @create="handleCreate"
        @refresh="handleRefresh"
      />
      <div>
        <CardFilter
          :org-info="orgInfo"
        />
        <CardList
          :data="data"
          :loading="loading"
          @update="handleUpdate"
          @delete="handleDelete"
        />
        <el-row
          type="flex"
          align="middle"
          justify="end"
          class="mt-l"
        >
          <el-pagination
            background
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="handleChangePageSize"
            @current-change="handleChangePage"
          />
        </el-row>
      </div>
      <DataFormPopup
        v-if="formVisible"
        :item="selectedItem"
        :visible="formVisible"
        :org-info="organization"
        @close="formVisible = false"
        @reload="fetchData"
      />
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CardFilter from "./components/CardFilter.vue";
import CardHeader from "./components/CardHeader.vue";
import CardList from "./components/CardList.vue";
import DataFormPopup from "./components/DataForm.vue";

import { notification } from "@/utils/common";
import roleServices from "@/services/role";

export default {
  name: "Roles",
  components: {
    CardHeader,
    CardFilter,
    CardList,
    DataFormPopup,
  },
  props: {
    orgInfo: Object
  },
  data() {
    return {
      loading: false,
      searchText: "",
      page: 1,
      pageSize: 10,
      total: 0,
      data: [],
      selectedItem: null,
      formVisible: false,
    };
  },
  computed: {
    ...mapGetters("organization", ["selectedOrg"]),
    organization() {
      return this.orgInfo || this.selectedOrg
    },
    params() {
      const _params = {
        q: this.searchText,
        offset: (this.page - 1) * this.pageSize,
        limit: this.page * this.pageSize,
        locale: "vi",
        sort: "-created",
        filters: {
          organization_id: this.organization.id
        }
      };
      return _params;
    },
  },
  watch: {
    selectedOrg: {
      handler() {
        this.fetchData()
      },
      deep: true,
      immediate: true,
    },
  },
  beforeMount() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      if (!this.selectedOrg) {
        return
      }
      this.loading = true;
      roleServices
        .list(this.params)
        .then((response) => {
          this.data = response.items.map((item, index) => ({
            ...item,
            stt: index + 1 + this.pageSize * (this.page - 1),
          }));
          this.total = response.meta.total;
          this.$emit('changeRoleTotal', response.meta.total)
          this.loading = false;
        })
        .catch(() => {
          this.data = [];
          this.loading = false;
        });
    },
    handleCreate() {
      this.selectedItem = null;
      this.formVisible = true;
    },
    handleUpdate(item) {
      this.selectedItem = item;
      this.formVisible = true;
    },
    handleDelete(item) {
      this.$confirm(`Bạn có chắc chắn muốn xoá không?`, "Xác nhận", {
        confirmButtonText: "Xoá",
        cancelButtonText: "Huỷ",
        type: "warning",
      }).then(() => {
        roleServices
          .remove(item)
          .then(() => {
            if (this.data.length === 1 && this.page > 1) {
              this.page = this.page - 1;
            }
            this.fetchData();
            notification(this, "success", "delete", "quyền");
          })
          .catch(() => {
            notification(this, "error", "delete", "quyền hạn");
          });
      });
    },
    handleSearch() {
      this.page = 1;
      this.fetchData();
    },
    handleRefresh() {
      this.selectedItem = null;
      this.page = 1;
      this.searchText = "";
      this.fetchData();
    },
    handleChangePage(page) {
      this.page = page;
      this.fetchData();
    },
    handleChangePageSize(size) {
      this.page = 1;
      this.pageSize = size;
      this.fetchData();
    },
  },
};
</script>

<style lang="scss"></style>
